module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 018.6dbd1c4e.jpg";